import styled, { css } from "styled-components";

type TabProps = {
  active: Boolean;
};

export const TabsContainer = styled.div<any>`
  display: flex;
  padding-top: 8px;
  overflow: auto;
`;

export const Tab = styled.div`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;

  /* or 17px */
  display: flex;
  align-items: center;
  text-align: center;

  /* Donkergrijs */
  color: #212529;
  padding: 10px 20px;
  cursor: pointer;

  width: 150px;
  text-align: center;
  justify-content: center;
  border-bottom: 4px solid #e5e5e5;
  ${({ active }: TabProps) =>
    active &&
    css`
      font-weight: bold;
      border-bottom: 4px solid #0075bc;
    `}
  &:hover {
    font-weight: bold;
  }
`;

export const TabContent = styled.div`
  display: none;
  ${({ active }: TabProps) =>
    active &&
    css`
      display: block;
    `}
`;
